/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ProductDraftsUserControllerFindManyQueryResponse,
  ProductDraftsUserControllerFindManyQueryParams,
  ProductDraftsUserControllerFindMany401,
} from '../types/ProductDraftsUserControllerFindMany.ts';

function getProductDraftsUserFindManyUrl() {
  const res = { method: 'GET', url: `/api/user/product-drafts` as const };
  return res;
}

/**
 * {@link /api/user/product-drafts}
 */
export async function productDraftsUserFindMany(
  params?: ProductDraftsUserControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    ProductDraftsUserControllerFindManyQueryResponse,
    ResponseErrorConfig<ProductDraftsUserControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getProductDraftsUserFindManyUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
